import parseDate from '../assets/parseDate'
import Server from '../server/server'

const getCapacity = async (arrObj) => {

    const arrInn = arrObj.map(item => {
        return item.inn
    })
    try {
        return (async () => {
            const promiseCapacity = await arrInn.map(inn => {
                const result = Server.getDataFromServer('capacityDate', inn)

                return result
            })

            const arrCapacity = await Promise.allSettled(promiseCapacity)

            const resultArr = arrCapacity.map(item => {
                return (
                    item?.value?.dateValue ? parseDate(item.value.dateValue) : 'Не указана'
                )
            })

            console.log(`RESULT capacity::: `, resultArr); // test

            return resultArr
        })()
    } catch (err) {
        console.log(`Ошибка получение данных о загрузке предприятия: `, err);
        return {}
    }



}

export default getCapacity;